import { render, staticRenderFns } from "./SearchLabbyLabID.vue?vue&type=template&id=42ced12e"
import script from "./SearchLabbyLabID.vue?vue&type=script&lang=js"
export * from "./SearchLabbyLabID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports